import { WprBaseValidator } from '../WprBaseValidator';

/**
 * 全角カタカナバリデータ
 */
export class WprZKanaValidator extends WprBaseValidator {
	// コンストラクタ  -----------------------------------------------------------
	public constructor() {
		super('全角カナ');
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * 入力値チェック
	 * @param value 入力値
	 * @param option チェックオプション
	 * @returns trueの場合、成功
	 */
	public checkValidValue(value: any, option?: any): boolean {
		if (!value)
			return true;
		if (typeof(value) === 'string' || value instanceof String) {
			if (value.match('^[ァ-ンヴー]*$') != null)
				return true;
		}
		return false;
	}

	/**
	 * エラーメッセージ取得
	 * @param description エラーが発生したコントロールの説明
	 * @param option オプション
	 * @returns エラーメッセージ
	 */
	public getErrorMessage(description: string, option?: any): string {
		return '全角カタカナを入力してください。';
	}
	// --------------------------------------------------------------------------
}
